import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'src/common/redux/store';
import { StateProps } from '../interfaces/admin-profile.interface';

const initialState: StateProps = {
  profile: {},
  showNewPassword: false,
  showOldPassword: false,
};
export const adminProfileSlice = createSlice({
  name: 'adminProfile',
  initialState,
  reducers: {
    setAdminInfo: (state, action) => {
      state.profile = action.payload;
    },
    setShowOldPassword: (state, action: PayloadAction<boolean>) => {
      state.showOldPassword = action.payload;
    },
    setShowNewPassword: (state, action: PayloadAction<boolean>) => {
      state.showNewPassword = action.payload;
    },
  },
});

export const { setAdminInfo, setShowNewPassword, setShowOldPassword } =
  adminProfileSlice.actions;

export const adminInfoSelector = (state: RootState) => state.adminProfile.profile;
export const adminShowOldSelector = (state: RootState) =>
  state.adminProfile.showOldPassword;
export const adminShowNewSelector = (state: RootState) =>
  state.adminProfile.showNewPassword;

export default adminProfileSlice.reducer;
